<template>
    <div class="pricing">
        <div class="content">
            <RoundBtn class="trans vertical close">
                <template v-slot:icon>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" xml:space="preserve">
                        <line fill="none" stroke="#555555" stroke-width="3" stroke-miterlimit="10" x1="32" y1="0" x2="0" y2="32"/>
                        <line fill="none" stroke="#555555" stroke-width="3" stroke-miterlimit="10" x1="32" y1="32" x2="0" y2="0"/>
                    </svg>
                </template>
            </RoundBtn>
            <hide-at :breakpoints="{small: 480, medium: 768}" breakpoint="mediumAndAbove">
                <PricingCardsMobile />
            </hide-at>
            <show-at :breakpoints="{small: 480, medium: 768, large: 900}" breakpoint="medium">
                <PricingCardsTablet />
            </show-at>
            <hide-at :breakpoints="{small: 480, medium: 768, large: 900}" breakpoint="mediumAndBelow">
                <PricingCardsDesktop />
            </hide-at>            
        </div>
    </div>
</template>

<script>
    import {showAt, hideAt} from 'vue-breakpoints'
    import RoundBtn from '@/components/Btns/RoundBtn.vue';
    import PricingCardsDesktop from './PricingCardsDesktop.vue';
    import PricingCardsTablet from './PricingCardsTablet.vue';
    import PricingCardsMobile from './PricingCardsMobile.vue';

    export default {
        name: 'PricingContent',
        components: {
            hideAt,
            showAt,
            RoundBtn,
            PricingCardsDesktop,
            PricingCardsTablet,
            PricingCardsMobile
        },
    }
</script>

<style lang="scss">
    .pricing {
        width: 100%;
        background: #ffffff;
        padding-bottom: 200px;
        display: flex;
        justify-content: center;

        .close {
            position: absolute;
            top: 50px;
            right: 0;
            margin-right: 0;
        }

        .content {
            position: relative;
            padding-top: 350px;

            .pricing-cards {
                display: inline-flex;
                .pricing-card {
                    background: #ffffff;
                    width: 100%;
                    .pricing-card-content {
                        padding-top: 70px;
                        padding-bottom: 40px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        border: 1px solid #e9e9e9;
                    }
                }
                .pricing__logo {
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .pricing__title {
                    margin-top: 20px;
                    font-weight : bold;
                    font-size : 18px;
                    z-index: 2;

                    &__underline {
                        margin-left: -15px;
                        height: 13px;
                        width: calc(100% + 30px);
                        margin-top: -10px;
                        z-index: 1;
                        opacity: 0.3;
                    }
                }
                .pricing__plan {
                    font-size: 54px;
                    margin-top: 20px;
                    position: relative;
                    &::before {
                        content: "$";
                        font-size: 14px;
                        position: absolute;
                        top: 7px;
                        left: -10px;
                    }
                }
                .pricing__cycle {
                    font-size: 14px;
                }
                .pricing__hr {
                    width: 100%;
                    height: 2px;
                    border: none;
                    margin-top: 30px;
                    margin-bottom: 30px;
                }
                .pricing__lists {
                    width: 100%;
                    display: flex;
                    padding: 0 25px;
                }
                .pricing__list {
                    width: 100%;
                    font-size: 14px;
                    margin: 0;
                    padding: 0 15px;

                    li {
                        padding-top: 10px;
                        padding-bottom: 10px;
                        list-style-type: none;
                        display: flex;
                        align-items: center;
                        svg {
                            margin-right: 10px;
                            min-width: 16.23px;
                        }
                    }
                }
                
                .pricing-card1 {
                    color : rgb(126, 186, 143);

                    .pricing__logo {
                        background: rgb(126, 186, 143);
                        width: 92px;
                        height: 92px;
                    }
                    .pricing__title {
                        &__underline {
                            background: rgb(126, 186, 143);
                        }
                    }
                    .pricing__hr {
                        background: rgba(126, 186, 143, 0.2);
                    }
                }
                .pricing-card2 {
                    margin-top: -50px;
                    box-shadow: 0px 0px 28px -5px #888888;
                    z-index: 2;
                    color : rgb(133, 149, 196);
                    .pricing-card-content {
                        padding-top: 55px;
                        border: none;
                    }
                    .pricing__logo {
                        background: rgb(133, 149, 196);
                        width: 114px;
                        height: 114px;
                    }
                    .pricing__title {
                        &__underline {
                            background: #99ACD7;
                        }
                    }
                    .pricing__hr {
                        margin-top: 74px;
                        background: rgba(133, 149, 196, 0.2);
                    }
                    .pricing__see-sample {
                        margin-top: 20px;
                        display: flex;
                        align-items: center;
                        color: rgb(133, 149, 196);
                        text-decoration: none;
                        border-bottom: 1px solid rgb(133, 149, 196);
                        padding-bottom: 5px;
                        svg {
                            margin-right: 10px;
                        }
                    }
                }
                .pricing-card3 {
                    color : rgb(199, 76, 143);

                    .pricing__logo {
                        background: rgb(199, 76, 143);
                        width: 92px;
                        height: 92px;
                    }
                    .pricing__title {
                        &__underline {
                            background: rgb(199, 76, 143);
                        }
                    }
                    .pricing__hr {
                        background: rgba(199, 76, 143, 0.2);
                    }
                }
            }
        }
    }
    @media (max-width: 479px) { 
        .pricing {
            background: initial;
            padding-bottom: 0px;

            .close {
                right: 50px;
            }

            .content {
                width: 100%;
                .pricing-cards {
                    display: block;
                    padding-left: 5%;
                    padding-right: 5%;
                    
                    .pricing-card {
                        margin: 5% 0;
                        .pricing-card-content {
                            padding-top: 0px;
                            padding-bottom: 0px;
                            flex-direction: row;
                            align-items: stretch;
                            border: none;
                            flex-wrap: wrap;
                            &-left {
                                width: 60%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                padding-top: 40px;
                                padding-bottom: 40px;
                            }
                            &-right {
                                width: 40%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                padding-top: 40px;
                                padding-bottom: 40px;
                            }
                            &-bottom {
                                flex-grow: 1;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                padding-top: 30px;
                                padding-bottom: 40px;
                                padding-left: 5%;
                                padding-right: 5%;
                            }
                        }
                    }

                    .pricing__lists {
                        padding: 0 15px;
                        flex-direction: column;
                        align-items: center;
                    }
                    .pricing__list {
                        padding: 0 5px;
                    }

                    .pricing-card1 {
                        .pricing__logo {
                            width: 75px;
                            height: 75px;
                            svg {
                                width: 26px;
                                height: 30px;
                            }
                        }
                        .pricing-card-content {
                            &-right {
                                border-left: 2px solid rgba(126, 186, 143, 0.2);
                            }
                            &-bottom {
                                border-top: 2px solid rgba(126, 186, 143, 0.2);
                            }
                        }
                    }
                    .pricing-card2 {
                        margin-top: 0px;
                        box-shadow: none;
                        .pricing__logo {
                            width: 75px;
                            height: 75px;
                            svg {
                                width: 34px;
                                height: 33px;
                            }
                        }
                        .pricing-card-content {
                            &-right {
                                border-left: 2px solid rgba(133, 149, 196, 0.2);
                            }
                            &-bottom {
                                border-top: 2px solid rgba(133, 149, 196, 0.2);
                            }
                        }
                    }
                    .pricing-card3 {
                        .pricing__logo {
                            width: 75px;
                            height: 75px;
                            svg {
                                width: 32px;
                                height: 40px;
                            }
                        }
                        .pricing-card-content {
                            &-right {
                                border-left: 2px solid rgba(199, 76, 143, 0.2);
                            }
                            &-bottom {
                                border-top: 2px solid rgba(199, 76, 143, 0.2);
                            }
                        }
                    }
                }
            }
        }
    }
    @media (min-width: 480px) and (max-width: 767px) { 
        .pricing {
            background: initial;
            padding-bottom: 0px;

            .close {
                right: 50px;
            }

            .content {
                width: 100%;
                .pricing-cards {
                    display: block;
                    padding-left: 5%;
                    padding-right: 5%;
                    
                    .pricing-card {
                        margin: 5% 0;
                        .pricing-card-content {
                            padding-top: 0px;
                            padding-bottom: 0px;
                            flex-direction: row;
                            align-items: stretch;
                            border: none;
                            &-left {
                                width: 40%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                padding-top: 40px;
                                padding-bottom: 40px;
                            }
                            &-right {
                                width: 60%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                padding: 40px 5%;
                            }
                        }
                    }

                    .pricing__lists {
                        padding: 0 15px;
                        flex-direction: column;
                        align-items: center;
                    }
                    .pricing__list {
                        padding: 0 5px;
                    }

                    .pricing-card1 {
                        .pricing__logo {
                            width: 75px;
                            height: 75px;
                            svg {
                                width: 26px;
                                height: 30px;
                            }
                        }
                        .pricing-card-content {
                            &-right {
                                border-left: 2px solid rgba(126, 186, 143, 0.2);
                            }
                        }
                    }
                    .pricing-card2 {
                        margin-top: 0px;
                        box-shadow: none;
                        .pricing__logo {
                            width: 75px;
                            height: 75px;
                            svg {
                                width: 34px;
                                height: 33px;
                            }
                        }
                        .pricing__see-sample-div {
                            width: 100%;
                            padding: 0 20px;
                            display: flex;
                        }
                        .pricing-card-content {
                            &-right {
                                border-left: 2px solid rgba(133, 149, 196, 0.2);
                            }
                        }
                    }
                    .pricing-card3 {
                        .pricing__logo {
                            width: 75px;
                            height: 75px;
                            svg {
                                width: 32px;
                                height: 40px;
                            }
                        }
                        .pricing-card-content {
                            &-right {
                                border-left: 2px solid rgba(199, 76, 143, 0.2);
                            }
                        }
                    }
                }
            }
        }
    }
    @media (min-width: 768px) and (max-width: 899px) {
        .pricing {
            .content {
                .pricing-cards {
                    .pricing__lists {
                        padding: 0 15px;
                        flex-direction: column;
                        align-items: center;
                    }
                    .pricing__list {
                        padding: 0 5px;
                    }

                    .pricing-card1 {
                        width: calc(239px + (249 - 239) * ((100vw - 768px) / (899 - 760)));
                        .pricing__logo {
                            width: 75px;
                            height: 75px;
                            svg {
                                width: 26px;
                                height: 30px;
                            }
                        }
                    }
                    .pricing-card2 {
                        width: calc(257px + (277 - 257) * ((100vw - 768px) / (899 - 760)));
                        .pricing__logo {
                            width: 86px;
                            height: 86px;
                            svg {
                                width: 39px;
                                height: 38px;
                            }
                        }
                        .pricing__hr {
                            margin-top: 85px;
                        }
                        .pricing__list {
                            width: 80%;
                        }
                    }
                    .pricing-card3 {
                        width: calc(239px + (249 - 239) * ((100vw - 768px) / (899 - 760)));
                        .pricing__logo {
                            width: 75px;
                            height: 75px;
                            svg {
                                width: 32px;
                                height: 40px;
                            }
                        }
                    }
                }
            }
        }
    }
    @media (min-width: 900px) and (max-width: 1199px) {
        .pricing {
            .content {
                .pricing-cards {
                    .pricing__lists {
                        padding: 0 15px;
                    }
                    .pricing__list {
                        padding: 0 5px;
                    }

                    .pricing-card1 {
                        width: calc(249px + (279 - 249) * ((100vw - 900px) / (1199 - 900)));
                    }
                    .pricing-card2 {
                        width: calc(277px + (385 - 249) * ((100vw - 900px) / (1199 - 900)));
                    }
                    .pricing-card3 {
                        width: calc(249px + (279 - 249) * ((100vw - 900px) / (1199 - 900)));
                    }
                }
            }
        }
    }
    @media (min-width: 1200px) {
        .pricing {
            .content {
                .pricing-cards {
                    .pricing-card1 {
                        width: 330px;
                    }
                    .pricing-card2 {
                        width: 440px;
                    }
                    .pricing-card3 {
                        width: 330px;
                    }
                }
            }
        }
    }
</style>